import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../constants/patterns';
import * as api from '../api/patterns';

function* fetchPatternSummarySaga(): any {
    try {
        const response = yield call(api.getSummary);
        yield put({ type: types.FETCH_PATTERN_SUMMARY_SUCCESS, payload: response });
    } catch (error: any) {
        yield put({ type: types.FETCH_PATTERN_SUMMARY_FAILURE, payload: error.message });
    }
}

function* fetchPatternsSaga(action: any): any {
    try {
        const response = yield call(api.getPatterns, action.payload);
        yield put({ type: types.FETCH_PATTERNS_SUCCESS, payload: response });
    } catch (error: any) {
        yield put({ type: types.FETCH_PATTERNS_FAILURE, payload: error.message });
    }
}

function* fetchPatternClaimsSaga(action: any): any {
    try {
        const response = yield call(api.getPatternClaims, action.payload);
        yield put({ type: types.FETCH_PATTERN_CLAIMS_SUCCESS, payload: response });
    } catch (error: any) {
        yield put({ type: types.FETCH_PATTERN_CLAIMS_FAILURE, payload: error.message });
    }
}

export default function* patternsSaga() {
    yield takeLatest(types.FETCH_PATTERN_SUMMARY_REQUEST, fetchPatternSummarySaga);
    yield takeLatest(types.FETCH_PATTERNS_REQUEST, fetchPatternsSaga);
    yield takeLatest(types.FETCH_PATTERN_CLAIMS_REQUEST, fetchPatternClaimsSaga);
}
